export default [
  {
    path: '/tools',
    name: 'tools',
    component: () => import('@/pages'),
    redirect: '/tools/package',
    meta: { title: '工具中心', icon: 'tool' },
    children: [
      {
        path: 'package',
        name: 'toolsPackage',
        component: () => import('@/pages/tools/package'),
        meta: { title: '安装包管理', icon: 'appstore', parent: 'tools' }
      },
      {
        path: 'sensors',
        name: 'sensors',
        component: () => import('@/pages/tools/sensors'),
        meta: { title: '埋点测试', icon: 'bar-chart', parent: 'tools' }
      },
      {
        path: 'sysCode',
        name: 'sysCode',
        component: () => import('@/pages/tools/sms_code'),
        meta: { title: '短信验证码', icon: 'code-sandbox', parent: 'tools' }
      },
      {
        path: 'cr/history',
        name: 'crHistory',
        component: () => import('@/pages/tools/merge/list.vue'),
        meta: { title: '代码CR', icon: 'bar-chart', parent: 'tools' }
      },
      {
        path: 'cr/detail',
        name: 'crDetail',
        component: () => import('@/pages/tools/merge/detail.vue'),
        meta: { title: 'CodeReview详情', icon: 'bar-chart', parent: 'tools' }
      }
    ]
  }
];
